import { useEffect, useState } from "react";
import { Box, Avatar, Skeleton, styled } from "@mui/material";
import CachedImage from "../../../../components/common/CachedImage";
import { ImagePath } from "../../../../assets/ImagePath";

const CameraIconWrapper = styled(Box)({
    position: "absolute",
    top: "78%",
    cursor: "pointer",
    right: "10%",
});


export const ProfileAvatar = ({ uploading, profileImage, user, uploadPhoto = () => { } }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        if (!profileImage) {
            setImageLoaded(false);
            return;
        }

        const img = new Image();
        img.src = profileImage;
        img.onload = () => setImageLoaded(true);
        img.onerror = () => setImageLoaded(false);
    }, [profileImage]);


    const getAvatarText = (userName) => {
        let letters = userName
            ? userName
                .split(" ")
                .map((n) => n[0])
                .join("")
            : "";
        return letters.slice(0, 2).toUpperCase();
    };


    return (
        <Box sx={{ position: "relative" }}>
            {uploading ?
              <Skeleton
                    variant="circular"
                    width={106}
                    height={107}
                    animation="wave"
                />
            : profileImage && imageLoaded ? (
                <Avatar
                    src={profileImage}
                    sx={{
                        width: 106,
                        height: 107,
                        borderRadius: "50%",
                    }}
                />
            ) : user && user.userName ? (
                <Avatar
                    sx={{
                        bgcolor: "#c5af91",
                        width: 106,
                        height: 107,
                        fontSize: "3.5rem",
                        fontWeight: "300",
                    }}
                >
                    {getAvatarText(user.userName)}
                </Avatar>
            ) : (
                <Skeleton
                    variant="circular"
                    width={106}
                    height={107}
                    animation="wave"
                />
            )}
            <CameraIconWrapper>
                <label htmlFor="fileBrowser" style={{ cursor: 'pointer' }}>
                    <CachedImage
                        imgKey={"cameraIcons"}
                        image={ImagePath.profileCamera}
                    />
                </label>
                <input
                    style={{ position: "absolute", cursor: "pointer", display: 'none' }}
                    type="file"
                    id="fileBrowser"
                    name="customFile"
                    accept=".png"
                    onChange={(e) => uploadPhoto(e)}
                />

            </CameraIconWrapper>
        </Box>
    );
};
